import React from "react";
// import { PieChart } from "@mui/x-charts/PieChart";

const PieChartComponent = (props) => {
  return (
    <></>
    // <PieChart {...props}

    // />
  );
};

export default PieChartComponent;
